import styled from 'styled-components'
import colorConfig from '../../colorConfig'

// ┌──────────────────────────────────────────────────────────────────────────────┐
// │ Brukes for å få farge på selected tab som er en Link                         │
// └──────────────────────────────────────────────────────────────────────────────┘

export const TabWrapper = styled.div`
    font-family: 'RM Neue', sans-serif;    

    font-size: 20px;   
    background-color: white;
    padding: 4px;
    color: ${colorConfig.mork};
    .nav-link {        
        color: ${colorConfig.mork}  !important;
        font-weight: 500;
    }
    .nav-link.active {
        background-color: ${colorConfig.button_bg}  !important;
        color: ${colorConfig.mork}  !important;
        font-weight: 800;
    }
`